import { getConfig } from '@cian/config/browser';

function setupWebpackPublicPath() {
    const config = getConfig();
    const publicPath = config.getStrict('web.manifest.assetsBaseUrl');
    // eslint-disable-next-line
    __webpack_public_path__ = publicPath;
}

export { setupWebpackPublicPath };
//# sourceMappingURL=setup.mjs.map
